import { render, staticRenderFns } from "./DocumentPortalSetupDossierView.vue?vue&type=template&id=b334d70e&scoped=true&"
import script from "./DocumentPortalSetupDossierView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalSetupDossierView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalSetupDossierView.vue?vue&type=style&index=0&id=b334d70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b334d70e",
  null
  
)

export default component.exports